/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Alert,
} from "reactstrap";
import api from "../../../services/axiosConfig";

function ComunicadoFormModal({ isOpen, toggle }) {
  const [formData, setFormData] = useState({
    title: "",
    content: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const fetchStatus = async () => {
        
      };

      fetchStatus();
    }
  }, [isOpen]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    const finalValue =  value;
    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (event) => {
    
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Envio de comunicados</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {isLoading && !formData.title ? (
            <div className="text-center">
              <Spinner color="primary">Loading...</Spinner>
            </div>
          ) : (
            <>
              <FormGroup>
                <Label for="title">Título</Label>
                <Input
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  active
                />
              </FormGroup>
              <FormGroup>
                <Label for="content">Conteúdo</Label>
                <Input
                  id="content"
                  name="content"
                  type="textarea"
                  rows={4}
                  value={formData.content}
                  onChange={handleChange}
                  required
                  active
                />
              </FormGroup>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={isLoading}>
            Cancelar
          </Button>
          <Button color="primary" type="submit" disabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : "Salvar"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default ComunicadoFormModal;
